import React from 'react';
import { Outlet } from 'react-router-dom';

import '../../Mobile.css';
function Consumer() {

  return (
    <>
      <Outlet />
    </>
  );
}

export default Consumer;